import { EventRegistrationConnector } from '@/events/pages/event-registration/connector';
import { EventDetailsModalV2 } from '@/events/components/event-details-modal-v2';

export const EventRegistration = EventRegistrationConnector(EventDetailsModalV2);
